var _path, _path2, _g, _path3, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.319 20.7051H4.433C1.989 20.7051 0 18.7161 0 16.2701V5.14108C0 2.69508 1.989 0.705078 4.433 0.705078H9.308C11.754 0.705078 13.744 2.69508 13.744 5.14108V6.07308C13.744 6.48708 13.408 6.82308 12.994 6.82308C12.58 6.82308 12.244 6.48708 12.244 6.07308V5.14108C12.244 3.52108 10.927 2.20508 9.308 2.20508H4.433C2.816 2.20508 1.5 3.52108 1.5 5.14108V16.2701C1.5 17.8891 2.816 19.2051 4.433 19.2051H9.319C10.931 19.2051 12.244 17.8931 12.244 16.2811V15.3381C12.244 14.9241 12.58 14.5881 12.994 14.5881C13.408 14.5881 13.744 14.9241 13.744 15.3381V16.2811C13.744 18.7211 11.758 20.7051 9.319 20.7051Z",
    fill: "#00286E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5055_280",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 9,
    width: 15,
    height: 3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99609 9.95508H20.537V11.4551H6.99609V9.95508Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5055_280)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7871 11.4551H7.74609C7.33209 11.4551 6.99609 11.1191 6.99609 10.7051C6.99609 10.2911 7.33209 9.95508 7.74609 9.95508H19.7871C20.2011 9.95508 20.5371 10.2911 20.5371 10.7051C20.5371 11.1191 20.2011 11.4551 19.7871 11.4551Z",
    fill: "#0E0E0E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5055_280",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 7,
    width: 5,
    height: 8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1094 7.04004H20.5367V14.3708H16.1094V7.04004Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5055_280)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8591 14.3708C16.6671 14.3708 16.4741 14.2978 16.3281 14.1498C16.0361 13.8558 16.0371 13.3818 16.3301 13.0898L18.7241 10.7048L16.3301 8.32079C16.0371 8.02879 16.0351 7.55479 16.3281 7.26079C16.6201 6.96679 17.0941 6.96679 17.3881 7.25879L20.3161 10.1738C20.4581 10.3138 20.5371 10.5058 20.5371 10.7048C20.5371 10.9038 20.4581 11.0958 20.3161 11.2358L17.3881 14.1518C17.2421 14.2978 17.0501 14.3708 16.8591 14.3708Z",
    fill: "#0E0E0E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg6);
export default __webpack_public_path__ + "static/media/svg6.993a505829a428cb2afcbb9814eb72f9.svg";
export { ForwardRef as ReactComponent };